// extracted by mini-css-extract-plugin
export var cardContainer = "_nd-0";
export var cardHeader = "_nd-2";
export var collapsedState = "_nd-3";
export var dragHandle = "_nd-5";
export var dragHandleIcon = "_nd-6";
export var dragging = "_nd-1";
export var titleArea = "_nd-4";